import { Button, TablePagination, useTheme } from '@mui/material';
import { MdArrowBack, MdArrowForward } from '@teamworksdev/icons';
import React from 'react';
import { useDataTableContext } from './data-table-context';

// Copied from the other paginated component, but this uses the table context
export function PaginationFooter() {
  const {
    palette: { greyscaleLight },
  } = useTheme();
  const { table, pageSizeOptions } = useDataTableContext();
  const { pageIndex, pageSize: tablePageSize } = table.getState().pagination;
  const rowCount = table.getRowCount();

  return (
    <TablePagination
      component={'div'}
      rowsPerPageOptions={pageSizeOptions}
      count={rowCount}
      rowsPerPage={tablePageSize}
      page={pageIndex}
      slotProps={{
        select: {
          inputProps: {
            'aria-label': 'rows per page',
          },
        },
      }}
      onPageChange={(_, newPage) => {
        table.setPageIndex(newPage);
      }}
      onRowsPerPageChange={(e) => table.setPageSize(Number(e.target.value))}
      ActionsComponent={TablePaginationActions}
      sx={{
        width: '100%',
        height: '56px',
        maxHeight: '100%',
        overflowY: 'hidden',
        flexShrink: 0,
        borderTop: '1px solid',
        borderColor: greyscaleLight[200],

        '& .MuiToolbar-root': {
          paddingX: 2,
        },
        '& .MuiTablePagination-spacer': {
          order: 2,
        },
        '& .MuiTablePagination-selectLabel': {
          order: 0,
        },
        '& .MuiTablePagination-select': {
          order: 1,
          padding: 0,
        },
        '& .MuiTablePagination-displayedRows': {
          order: 3,
          paddingRight: 2,
        },
        '& .MuiTablePagination-actions': {
          order: 4,
        },
      }}
    />
  );
}

interface TablePaginationActionsProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number,
  ) => void;
}

function TablePaginationActions({
  count,
  page,
  rowsPerPage,
  onPageChange,
}: TablePaginationActionsProps) {
  const handleBackButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    onPageChange(event, page + 1);
  };
  return (
    <div className="flex flex-row w-min order-4 space-x-2">
      <Button
        variant="outlined"
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
        sx={{ height: '26px', width: '26px', padding: 0 }}
      >
        <MdArrowBack size={16} />
      </Button>
      <Button
        variant="outlined"
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
        sx={{ height: '26px', width: '26px', padding: 0 }}
      >
        <MdArrowForward size={16} />
      </Button>
    </div>
  );
}
